<template>
    <div>
        <strong>Description:</strong>
        <p>
            Gets all project tasks one by one, and checks if <sui-label>technicalData</sui-label> is <sui-label>null</sui-label>
        </p>
        <p v-if="hasTechDataCount || noTechDataCount">
            Found <strong>{{ hasTechDataCount }}</strong> tasks with technical data,<strong>{{ partialTechDataCount }}</strong> tasks with partial technical data, <strong>{{ noTechDataCount }}</strong> tasks without technical data.
        </p>
        <hr />

        <sui-button primary size="tiny" :loading="isRunning" :disabled="isRunning" @click="triggerDry">Run Dry</sui-button>
        <!-- <sui-button negative size="tiny" :loading="isRunning" :disabled="isRunning" @click="triggerNormal">Run</sui-button> -->
         <sui-button negative size="tiny" :disabled="!isRunning" @click="stop">STOP</sui-button>
    </div>
</template>
<script>
import { DataAPI } from '../../../lib/DataAPI.js'

export default {
    name: 'CheckProjectTaskForTechData',

    mixins: [DataAPI],

    data() {
        return {
            isRunning: false,
            dryRun: true,
            hasTechDataCount: 0,
            partialTechDataCount: 0,
            noTechDataCount: 0,
            partialData: [],
            noData: [],
            shouldStop: false
        }
    },

    methods: {
        log(message) {
            this.$emit('log', message);
        },

        async triggerDry() {
            this.dryRun = true;
            await this.trigger();
        },

        async triggerNormal() {
            this.dryRun = false;
            await this.trigger();
        },

        stop() {
            this.shouldStop = true;
        },

        async trigger() {
            this.isRunning = true;
            this.log(`----------------`);
            this.log(`Starting process`);

            // if (this.dryRun) {
            //     this.log(`Dry mode - No updates will actually occur.`);
            // }
            // this.log('----------------');

            this.log('Getting projectTasks');
            const allProjectTasks = await this.dataGetAllProjectTasks()
            this.log(`Found ${allProjectTasks.length} project tasks`);

            // Define batch size
            const batchSize = 20;

            // Group tasks into batches
            const batches = [];
            for (let i = 0; i < allProjectTasks.length; i += batchSize) {
                batches.push(allProjectTasks.slice(i, i + batchSize));
            }
            this.log(`Split into ${batches.length} batches of maximum ${batchSize} tasks each`);

            for (const batch of batches) {
                if (this.shouldStop) {
                    this.log(`Process stopped by user.`);
                    break;
                }
                await Promise.all(batch.map(async (projectTask) => {
                    if (this.shouldStop) {
                        // this.log(`Process stopped by user.`);
                        return false;
                    }
                    return this.dataGetProjectTask(projectTask).then((task) => {
                        if (!task.configurationItem.technicalData) {
                            this.noTechDataCount++;
                            this.log(`Project Task ${task.id} has no technicalData`);
                            this.noData.push({
                                instNr: task.configurationItem.label,
                                taskCode: task.code,
                                techData: task.configurationItem.technicalData
                            });
                            return false;
                        } else if (!task.configurationItem.technicalData.asrName || !task.configurationItem.technicalData.asrPort || !task.configurationItem.technicalData.caTVPort) {
                            this.log(`Project Task ${task.id} has technicalData with missing data (asrName: ${task.configurationItem.technicalData.asrName || 'missing'}, asrPort: ${task.configurationItem.technicalData.asrPort || 'missing'}, caTVPort: ${task.configurationItem.technicalData.caTVPort || 'missing'})`);
                            this.partialTechDataCount++;
                            this.partialData.push({
                                instNr: task.configurationItem.label,
                                taskCode: task.code,
                                techData: task.configurationItem.technicalData
                            });
                            return false;
                        } else {
                            this.hasTechDataCount++;
                            this.log(`Project Task ${task.id} has technicalData`);
                            return true;
                        }
                    }).catch((error) => {
                        this.log(`Error fetching project task ${projectTask.id}: ${error.message}`);
                    });
                }));
            }

            this.log(`----------------`);

            for (const data of this.noData) {
                this.log(`No technicalData for ${data.instNr} (${data.taskCode}): \n${JSON.stringify(data.techData)}`);
            }
            for (const data of this.partialData) {
                this.log(`Partial technicalData for ${data.instNr} (${data.taskCode}): ${JSON.stringify(data.techData)}`);
            }

            this.log(`----------------`);

            this.log(`Found ${this.hasTechDataCount} project tasks with technicalData`);
            this.log(`Found ${this.noTechDataCount} project tasks without technicalData`);

            this.log(`----------------`);
            this.log(`Finished process`);

            this.isRunning = false
        }
    }
}
</script>
<style scoped>
.float.right {
    float: right;
}
</style>